import axios from 'axios'
import { ensureCsrfToken } from '../../../lib/csrf'

const url = (program, id) => `/api/digital-risk/programs/${encodeURIComponent(program)}/current-evidence/${id == null ? '' : `${encodeURIComponent(id)}/`}`
export const readProgramEvidence = async (program, id) => {
    const { data } = await axios.get(url(program, id), { withCredentials: true })
    return data
}
export const approveProgramEvidence = async (program, id, comments, { ready, onSending }) => {
    let token
    try {
        if (!await ready()) throw new Error('Session readiness could not be confirmed.')
        token = await ensureCsrfToken()
        if (!await ready()) throw new Error('Approval intent is no longer current.')
    } catch (cause) {
        throw Object.assign(new Error('Approval was not sent. Review your session and try again deliberately.'), { notSent: true })
    }
    // ready performs its own synchronous fence after every await. No await occurs
    // between this final guard, the conservative send boundary, and POST.
    if (!ready.isCurrent()) throw Object.assign(new Error('Approval was not sent.'), { notSent: true })
    onSending()
    const { data } = await axios.post(url(program, id), { comments }, {
        withCredentials: true, headers: { 'X-CSRFToken': token }, timeout: 30000,
    })
    return data
}
